import React from 'react';

import {
  Container,
  styled
} from '@mui/material';
import { AppBar } from 'modules';



const RootContainer = styled(Container)(({ theme }) => ({
  marginTop: (theme.mixins.toolbar.minHeight ?? 0)
}));



export interface IProps {
  children?: React.ReactNode | React.ReactNode[];
}

export const FC: React.FC<IProps> = props => {
  return (
    <>
      <AppBar.FC layoutVariant='superAdmin' />

      <RootContainer>
        {props.children}
      </RootContainer>
    </>
  );
};
